var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 69,
    viewBox: "0 0 229 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.168 38.2178C189.346 38.2178 194.354 33.2098 194.354 27.032C194.354 20.8542 189.346 15.8462 183.168 15.8462C176.99 15.8462 171.982 20.8542 171.982 27.032C171.982 33.2098 176.99 38.2178 183.168 38.2178ZM183.168 41.7134C191.276 41.7134 197.849 35.1403 197.849 27.032C197.849 18.9237 191.276 12.3506 183.168 12.3506C175.059 12.3506 168.486 18.9237 168.486 27.032C168.486 35.1403 175.059 41.7134 183.168 41.7134Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0239 27.0322C34.0239 33.21 39.032 38.2181 45.2097 38.2181C49.9636 38.2181 54.029 35.2518 55.6478 31.063L58.9084 32.323C56.7864 37.8141 51.4556 41.7136 45.2097 41.7136C37.1014 41.7136 30.5283 35.1405 30.5283 27.0322H34.0239Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2097 15.8462C40.2527 15.8462 36.0488 19.0706 34.5809 23.5364H55.8386C54.3707 19.0706 50.1668 15.8462 45.2097 15.8462ZM59.4725 23.5364C57.9043 17.1157 52.1135 12.3506 45.2097 12.3506C38.306 12.3506 32.5152 17.1157 30.947 23.5364C30.6734 24.6567 30.5283 25.8274 30.5283 27.032H59.8912C59.8912 25.8274 59.7461 24.6567 59.4725 23.5364Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6814 25.8673C20.8592 25.8673 25.8673 20.8592 25.8673 14.6814C25.8673 8.50365 20.8592 3.49558 14.6814 3.49558C8.50365 3.49558 3.49558 8.50365 3.49558 14.6814C3.49558 20.8592 8.50365 25.8673 14.6814 25.8673ZM14.6814 29.3628C22.7897 29.3628 29.3628 22.7897 29.3628 14.6814C29.3628 6.57309 22.7897 0 14.6814 0C6.57309 0 0 6.57309 0 14.6814C0 22.7897 6.57309 29.3628 14.6814 29.3628Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49558 14.6816V41.7141H0V14.6816H3.49558Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9224 26.7998C86.9224 20.622 81.9143 15.614 75.7366 15.614C69.5588 15.614 64.5507 20.622 64.5507 26.7998H61.0551C61.0551 18.6915 67.6282 12.1184 75.7366 12.1184C83.8449 12.1184 90.418 18.6915 90.418 26.7998H86.9224Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5512 12.3516V41.7144H61.0557V12.3516H64.5512Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4184 26.7998L90.4184 41.7143L86.9229 41.7143L86.9229 26.7998L90.4184 26.7998Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.882 26.7998C224.882 20.622 219.874 15.614 213.697 15.614C207.519 15.614 202.511 20.622 202.511 26.7998H199.015C199.015 18.6915 205.588 12.1184 213.697 12.1184C221.805 12.1184 228.378 18.6915 228.378 26.7998H224.882Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.51 14.6816V41.7141H199.015V14.6816H202.51Z",
    fill: "currentColor"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.377 26.7998L228.377 41.7143L224.882 41.7143L224.882 26.7998L228.377 26.7998Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.112 38.2178C128.29 38.2178 133.298 33.2098 133.298 27.032C133.298 20.8542 128.29 15.8462 122.112 15.8462C115.934 15.8462 110.926 20.8542 110.926 27.032C110.926 33.2098 115.934 38.2178 122.112 38.2178ZM122.112 41.7134C130.22 41.7134 136.793 35.1403 136.793 27.032C136.793 18.9237 130.22 12.3506 122.112 12.3506C114.004 12.3506 107.431 18.9237 107.431 27.032C107.431 35.1403 114.004 41.7134 122.112 41.7134Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.793 26.7988L136.793 41.7133L133.298 41.7133L133.298 26.7988L136.793 26.7988Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.64 38.2178C158.818 38.2178 163.826 33.2098 163.826 27.032C163.826 20.8542 158.818 15.8462 152.64 15.8462C146.463 15.8462 141.455 20.8542 141.455 27.032C141.455 33.2098 146.463 38.2178 152.64 38.2178ZM152.64 41.7134C160.749 41.7134 167.322 35.1403 167.322 27.032C167.322 18.9237 160.749 12.3506 152.64 12.3506C144.532 12.3506 137.959 18.9237 137.959 27.032C137.959 35.1403 144.532 41.7134 152.64 41.7134Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.457 54.0645C141.457 60.2422 146.465 65.2503 152.642 65.2503C158.82 65.2503 163.828 60.2422 163.828 54.0645H167.324C167.324 62.1728 160.751 68.7459 152.642 68.7459C144.534 68.7459 137.961 62.1728 137.961 54.0645H141.457Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.322 26.7988L167.322 54.0643L163.826 54.0643L163.826 26.7988L167.322 26.7988Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0796 27.0322C95.0796 33.21 100.088 38.2181 106.265 38.2181V41.7136C98.1571 41.7136 91.584 35.1405 91.584 27.0322H95.0796Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0796 -1.52796e-07L95.0796 27.0324L91.584 27.0324L91.584 0L95.0796 -1.52796e-07Z",
    fill: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.274 12.351H87.6221V8.85547H99.274V12.351Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.11a489ccf8808479be98f790cd492a15.svg";
export { ForwardRef as ReactComponent };